// src/pages/travelplanner/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "./Collectionpage";
import { getTravelPlanners, PRODUCTS_PER_PAGE } from "../data/travelPlanners";
import SEOHead from "../components/common/SEOHead";
import ProductListSchema from "../components/common/ProductListSchema";
import FAQSchema from "../components/common/FAQSchema";

const PAGE_URL = "https://aishcraft.com/travel-planner";

const travelPlannerFAQs = [
  {
    question: "What can I use a travel planner for?",
    answer: "Travel planners help you organize itineraries, track expenses, and keep memories of every trip in one beautiful keepsake.",
  },
  {
    question: "Can I personalize the cover with my name?",
    answer: "Yes, every travel planner can be customized with your name, initials, or a custom message on the cover.",
  },
  {
    question: "How long does delivery take?",
    answer: "Personalized travel planners are made to order and typically ship within 6 working days across India.",
  },
];

export default function TravelPlanner() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getTravelPlanners()
      .then(setProducts)
      .catch((err) => setError(err.message || "Failed to load products"));
  }, []);

  const seo = (
    <SEOHead
      title="Travel Planners | Personalized Table Calendars"
      description="Shop 300+ beautifully designed personalized travel planners. Premium quality, customizable — every journey deserves a beautiful plan."
      url={PAGE_URL}
      breadcrumbs={[
        { name: "Home", item: "https://aishcraft.com/" },
        { name: "Travel Planner", item: PAGE_URL },
      ]}
    />
  );

  if (error) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>
      </>
    );
  }

  if (!products) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>
      </>
    );
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/travel-planner",
    announcement: {
      headline: "Plan your next adventure in style!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Table Calenders",
      subtitle: "Every journey deserves a beautiful plan",
      featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "I've used this on every trip — it keeps me organised and doubles as a beautiful keepsake.",
      quoteLink: "#",
      rating: "4.7",
      ratingCount: "1000+",
    },
  };

  return (
    <>
      {seo}
      <ProductListSchema products={products} pageUrl={PAGE_URL} />
      <FAQSchema faqs={travelPlannerFAQs} />
      <CollectionPage config={config} />
    </>
  );
}